export default __webpack_public_path__ + "public/assets/images/e103b240338f8c2af5ec37a242782af1.png";